import * as React from "react";
import { useCallback, useMemo } from "react";
import EventProcedureDetailsView from "security-app/components/SecurityEvents/EventProcedures/EventProcedureDetailsView";
function useTableElements() {
  const renderExpanded = useCallback(
    (eventProcedure) => /* @__PURE__ */ React.createElement(EventProcedureDetailsView, { eventProcedure, descriptionMaxHeight: 400, row: true }),
    []
  );
  const expandedSections = useMemo(
    () => ({
      restFieldsExpandedSection: {
        title: null,
        content: renderExpanded
      }
    }),
    [renderExpanded]
  );
  return {
    expandedSections
  };
}
export default useTableElements;
